let language = {
    SELECT_STORE_PRODUCT_TYPE_TITLE: "请选择要添加的店铺产品类型",
    SELECT_STORE_PRODUCT_TYPE_NULL_TYPE_TIP: "目前没有可供选择的店铺产品类型",
    // 店铺产品类型
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_WITHOUT_DESIGN_NAME: "添加一个完全可定制的空白产品",
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_WITHOUT_DESIGN_DES: "为您的客户提供完全自定义产品的灵活性，允许他们根据自己的喜好选择所有打印功能和选项。",
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_NAME: "添加您的设计",
    SELECT_STORE_PRODUCT_TYPE_SKU_WITH_DESIGN_DES: "将您独特的设计添加到我们的产品中。在后续步骤中，您可以选择让客户自定义您的设计或保持原样。完成后，您只需将其添加到您的店铺，准备开始销售吧！",
    SELECT_STORE_PRODUCT_TYPE_FULL_WITHOUT_DESIGN_NAME: "添加空白产品",
    SELECT_STORE_PRODUCT_TYPE_FULL_WITHOUT_DESIGN_DES: "将一个空白产品添加到您的电子商店，并允许客户通过文本和图片进行自定义。",

    // 成品产品--可添加店铺产品类型名称
    SELECT_STORE_PRODUCT_TYPE_SKU_PRODUCT_NAME: "添加空白产品",
    SELECT_STORE_PRODUCT_TYPE_FULL_PROPERTY_NAME: "添加一个完全可定制的空白产品"
};

export { language }
